export const SettingsMixin = {
  data () {
    return {
      weekOption:['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      monthDay:[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      settings_obj:
        {
          course_type: 1,
          currency_id: JSON.parse(localStorage.getItem('localization')).currency_id,
          payment_option: 1,
          installment_no_id: 1,
          total_price: 0,
          installment_price: 0,
          installment_start_date: new Date().toISOString().slice(0, 10),
          enrollment_rule: 1,
          signup_approval: 1,
          downgrade_allowed: 1,
          structured_content: 'free_form',
          lesson_has_topic: 1,
          course_has_activities: 1,
          course_need_space: 1,
          course_invisible_to_student: 1,
          lesson_has_homework: 1,
          make_homework_visible: 1,
          course_has_equipments: 1,
          automatic_renewal: 1,
          lesson_setup: 1,
          no_of_sessions: 1,
          session_frequency: 1,
          reschedule_allowed: 1,
          reschedule_count:1,
          session_during_school_holiday: 1,
          class_size: 1,
          session_frequency_hour: 0,
          session_frequency_minute: 0,
          course_start_date: new Date().toISOString().slice(0, 10),
          course_end_date: new Date().toISOString().slice(0, 10),
          join_end_date:new Date().toISOString().slice(0, 10),
          has_exam: 1,
          completion_certificate: 1,
          progress_report: 1,
          prerequisites: 1,
          course_start_time:null,
          course_end_time :null,
          course_class_place :'', //1  school, 2 home
          course_class_type:'self_based',
          application_deadline:new Date().toISOString().slice(0, 10),
          session_frequency_month_day:[],
          session_frequency_week_day:[],
          class_duration:null,
          session_duration:null, //in minutes
          assets:[],
          can_chat_with_participants :false,
          max_days_in_week_or_month:null,

          //new module

          course_timeline: 'specific', /* specific/not_specific */
          content_visibility: 0, //0/1
          minimum_time_requirement_prior_to_booking: 0 //in minutes
          //new module
        },
      coursePLaceType:[
        {
          place_name:'At School',
          id:1
        },
        {
          place_name:'At Home',
          id:2
        },
        {
          place_name:'Online',
          id:3
        }

      ],
      course_class_type_list:[
        {
          value:'self_based',
          name:'Self Paced Course'
        },
        {
          value:'online_one_2_one',
          name:'Online Individual Course'
        },
        {
          value:'online_one_2_many',
          name:'Online Group Course'
        },
        {
          value:'offline_one_2_one',
          name:'In Person Individual Course'
        },
        {
          value:'offline_one_2_many',
          name:'In Person Group Course'
        }
      ]

    }
  },
  methods: {
    checkingStartEndTiming (settings_object) {


      if (settings_object.course_start_time == null && settings_object.course_end_time == null) {
        return true
      } else if (this.timeStringToFloat(settings_object.course_start_time) >= this.timeStringToFloat(settings_object.course_end_time)) {


        return false
      }
    },
    timeStringToFloat (time) {
      if (time === null) {
        return false
      }
      const hoursMinutes = time.split(/[.:]/)
      const hours = parseInt(hoursMinutes[0], 10)
      const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0
      return hours + minutes / 60
    }

    /*  configEnd () {

    } */


  },
  computed:{
    checkingClassType () {
      if (this.settings_obj.course_class_type != 'self_based' &&
      this.settings_obj.course_class_type != 'online_one_2_one'
      && this.settings_object.course_timeline === 'specific'
      ) {
        return true
      } else {
        return false
      }
    },
    one2ManyType () {
      if (this.settings_obj.course_class_type == 'online_one_2_many'
      ||
      this.settings_obj.course_class_type == 'offline_one_2_many'
      ) {
        return true
      } else {
        return false
      }
    },
    hasSelfPaced () {
      if (this.settings_obj.course_class_type == 'self_based'
      ) {
        return true
      } else {
        return false
      }
    },
    hasCourseTimeLinesSpecificDate () {
      if (this.one2ManyType() && this.settings_obj.course_timeline) {
        return true
      } return false
    },
    hasOne2OneChecking () {
      if (this.settings_obj.course_class_type == 'online_one_2_one'
      ||
      this.settings_obj.course_class_type == 'offline_one_2_one'
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
